import { baseUrl } from '@/config'
import Api from '@/lib/api'

const getDefaultState = () => {
  return {
    baseUrl,
    userProfile: null,
    schools: [],
    filterBySchool: null,
    approvedTutors: []
  }
}

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    reset(state) {
      Object.assign(state, getDefaultState())
    },
    setSchools(state, payload) {
      state.schools = payload
    },
    setUserProfile(state, payload) {
      state.userProfile = payload
    },
    setFilterBySchool(state, payload) {
      state.filterBySchool = payload
    },
    setApprovedTutors(state, payload) {
      state.approvedTutors = payload
    }
  },
  actions: {
    onInit({ rootState, dispatch }) {
      if (rootState.auth.isAuthenticated()) {
        dispatch('getUserProfile')
      }
    },
    getSchools({ commit }) {
      return Api()
        .get('schools', {
          params: {
            _fields: '_id,name'
          }
        })
        .then(response => {
          const list = response.data.result.map(item => {
            return { id: item._id, name: item.name }
          })

          commit('setSchools', list)
        })
    },
    getUserProfile({ commit, state, dispatch }) {
      return Api()
        .get('users/detail')
        .then(response => {
          commit('setUserProfile', response.data.result)
          if (state.userProfile && state.userProfile.role !== 'superadmin') {
            const { _id, name } = state.userProfile.school;
            localStorage.setItem('schoolId', _id);
            commit('setFilterBySchool', { id: _id, name })
            commit('setSchools', [
              {
                id: _id,
                name
              }
            ])
          } else {
            localStorage.removeItem('schoolId');
            commit('setFilterBySchool', true)
            dispatch('getSchools')
          }
        })
    },

    getApprovedTutorsBySchool({ commit }, schoolId) {
      return Api()
        .get('studentsCms', {
          params: {
            _fields: '_id,firstName,lastName',
            schoolId: schoolId,
            activeTutor: true,
            isDeleted: false
          }
        })
        .then(response => {
          const tutors = response.data.result.map(tutor => ({
            value: tutor._id,
            text: `${tutor.firstName} ${tutor.lastName}`
          }))
          commit('setApprovedTutors', tutors)
        })
        .catch(error => {
          console.error('Error fetching approved tutors:', error)
          commit('setApprovedTutors', [])
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js